export default {
  init() {
    // JavaScript to be fired on the home page

	if(jQuery('#cff .cff-posts-wrap .cff-item').length){
		jQuery.each(jQuery('#cff .cff-no-image'), function (){
			jQuery(this).closest('.cff-item').remove();
		});
	}
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js